import _ from 'lodash';
import createReducer from './createReducer.js';
import * as types from '../../actions/types';

const initialState = {
	feed_logs: [],
	feed_scan_summary: {
		scanned_at: null,
		message: null,
	},
	vehicle_data_feeds: [],
	vehicle_data_feeds_loaded_at: null,
	feed_errors: [],
	feed_notification_settings: [],
	feed_provider_rules: [],
	feed_providers: [],
	feed_provider_settings: [],
	feed_dispatches: [],
	mpi_work_item_fields: [],
};

export const settings_feed = createReducer(initialState, {
	[types.SET_FEED_LOGS](state = initialState, action) {
		return {
			...state,
			feed_logs: action.feed_logs,
		};
	},
	[types.SET_FEED_SCAN_SUMMARY](state = initialState, action) {
		return {
			...state,
			feed_scan_summary: action.feed_scan_summary,
		};
	},
	[types.SET_VEHICLE_DATA_FEEDS](state = initialState, action) {
		return {
			...state,
			vehicle_data_feeds: action.vehicle_data_feeds,
			vehicle_data_feeds_loaded_at: action.vehicle_data_feeds_loaded_at,
		};
	},
	[types.SET_FEED_PROVIDERS](state = initialState, action) {
		return {
		  ...state,
		  feed_providers: action.feed_providers,
		};
	  },
	  [types.SET_FEED_PROVIDER_RULES](state = initialState, action) {
		return {
		  ...state,
		  feed_provider_rules: action.feed_provider_rules,
		};
	  },
	  [types.SET_FEED_PROVIDER_SETTINGS](state = initialState, action) {
		return {
		  ...state,
		  feed_provider_settings: action.feed_provider_settings,
		};
	  },
	  [types.SET_FEED_NOTIFICATION_SETTINGS](state = initialState, action) {
		return {
		  ...state,
		  feed_notification_settings: action.feed_notification_settings,
		};
	  },
	  [types.SET_FEED_ERRORS](state = initialState, action) {
		return {
		  ...state,
		  feed_errors: action.feed_errors,
		};
	  },
	  [types.SET_FEED_DISPATCHES](state = initialState, action) {
		return {
		  ...state,
		  feed_dispatches: action.feed_dispatches,
		};
	  },
	  [types.SET_MPI_WORK_ITEM_FIELDS](state = initialState, action) {
		return {
		  ...state,
		  mpi_work_item_fields: action.mpi_work_item_fields,
		};
	  },
	[types.RESET_REFRESH](state = initialState) {
		return {
			...state,
			feed_logs: [],
			feed_scan_summary: {
				scanned_at: null,
				message: null,
			},
			vehicle_data_feeds: [],
			vehicle_data_feeds_loaded_at: null,
			feed_errors: [],
			feed_notification_settings: [],
			feed_provider_rules: [],
			feed_providers: [],
			feed_provider_settings: [],
			feed_dispatches: [],
			mpi_work_item_fields: [],
				};
	},
});

export default 'settings_feed';
